module.exports = __webpack_public_path__ + "static/img/qunzhu_2.e0e9587d.jpg";